import * as fuzzysort from 'fuzzysort'

export interface FuzzyResult {
  target: string,
  score: number
}

export const fuzzySearch = (searchTerm: string, searchList: string[]): FuzzyResult[] =>
  fuzzysort.go(searchTerm, searchList).map(({ target, score }) => ({ target, score }))

